/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * karevi
 * CategoryForm.ts
 */

import {AbstractForm} from "../../../tools/model/form/AbstractForm";
import {VideoFileUploadDTO} from "../../dto/video/VideoFileUploadDTO";
import {Type} from "../../../tools/view/form/FormInput";
import {FileField} from "../../../tools/model/form/FileField";
import {DownloadField} from "../../../tools/model/form/DownloadField";
import {VideoFileType} from "../../../component/page/VideoPage";
import {ProgressWatcher} from "../../../tools/service/KareviHTTPService";
import {XMLHttpRequestProgressEvent} from "../../../services/VideoService";

export default class VideoFileForm extends AbstractForm<VideoFileUploadDTO> implements ProgressWatcher {
    fileType: VideoFileType
    fileUploadProgressPercent: number = -1

    constructor(fileType: VideoFileType, dto?: VideoFileUploadDTO) {
        super();

        this.fileType = fileType;

        this.fields.set("fileUrl", new DownloadField(
            "fileUrl",
            t => "URL",
            value => {
                console.error(value)
                return true
            },
            Type.URL,
            false,
            undefined,
            undefined,
            true,
            dto?.fileUrl
        ));

        this.fields.set("files", new FileField(
            "files",
            t => t.upload,
            _ => true,
            Type.URL,
            false,
            undefined,
            undefined,
            false
        ));

        if (dto) super.load(dto);
    }

    public onProgress = (progressEvent: XMLHttpRequestProgressEvent) => {
        //avoids too much useless computing

        let total = progressEvent.totalSize === undefined ? progressEvent.total : progressEvent.totalSize

        let percent = Math.floor(progressEvent.loaded * 100 / total)
        if (percent === this.fileUploadProgressPercent) return

        this.fileUploadProgressPercent = percent

        let fileField = this.fields.get("files")
        if (!fileField) return;
        fileField.title = (t) => `${t.upload} (${this.fileUploadProgressPercent}%)`

        this._notifyListener();
    };

    load(dto: VideoFileUploadDTO) {
        this.fileType = dto.fileType
        super.load(dto);
    }
}
